 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		64: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		64: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~reverse-image-search~stylequiz","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","7":"BuyItAgainTypeaheadPreWrapper","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews-mobile","12":"buybox~promotion-products-lazy","13":"compare~orange-lens","14":"media-gallery-overlay~media-gallery-overlay-mobile","15":"orange-lens~reverse-image-search","16":"ratings-and-reviews-desktop","17":"StoreLayout","18":"aisle-bay","19":"augmented-reality","20":"bath-renovation","21":"breadcrumbs","22":"browse-and-search","23":"browse-and-search-mobile","24":"buybox","25":"calculator-pipcalculator","26":"collections","27":"collections-mobile","28":"compare","29":"consumer-card-messaging","30":"customer-image-overlay","31":"drawer","32":"emt-generated-content","33":"emt-links","34":"fulfillment","35":"global-custom-configurator","37":"home","38":"magic-apron","39":"measurement-guide","40":"measurement-guide-overlay-content","41":"media-gallery-filmstrip-mobile","42":"media-gallery-overlay","43":"media-gallery-overlay-mobile","44":"message-types","45":"orange-lens","46":"order-sample","47":"order-sample-drawer","48":"overlay","49":"paint-reorder","50":"paint-reorder-mobile","51":"pep","52":"pep-mobile","53":"product","54":"product-mobile","55":"product-overview","56":"promotion-products-lazy","57":"question","58":"questions-and-answers","59":"quick-view","60":"ratings-and-reviews","61":"results","62":"returns-messaging","63":"reverse-image-search","65":"share-to-email-overlay","66":"share-to-pinterest-overlay","67":"size-guide-overlay","68":"specifications","69":"stylequiz","70":"vendor-collection-products","71":"vendor-collections","72":"vendor-collections-mobile","74":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"40f0d93fcc1c5ffddc9e","1":"30f240fabe191e5afaeb","2":"ac4d3308d2f76c9e666b","3":"db499435391b5a65d4dc","4":"fafe27ad2031a477b45d","5":"a68ab376dadc20d78cad","6":"09681a175882eaef54bc","7":"397b0db946a7dd52598e","8":"a8bb2316452006087a97","9":"3f1140ca93d4be4e3490","10":"40ddc5bb092c5c023bc1","11":"37f671a9194f1a1fdca4","12":"c43f78011ebe3b2686d5","13":"106f21b42f293c0a1733","14":"4681a77a458f2043c82a","15":"48fb8af99476f37470ac","16":"4b4c374c0e8cf0584312","17":"29ac506fb2b14d65480e","18":"790218f56bfe5e9eb5c7","19":"591b433249f903cf7cab","20":"3fa2a83ce3c50fc23833","21":"cedddf3c9865fab45a3c","22":"860b77a3af478208ce10","23":"3745e80c8aef9c11a942","24":"3647c3594b621de06353","25":"4374307e723685ea740c","26":"3e7f970ad7e7016a32b6","27":"33e6c314b9997580927f","28":"8aba8286f27dcdc3b511","29":"3db6968e7297c6102b1a","30":"3783841f85d0fcec9d86","31":"e3ef53cd31a0f497707b","32":"471c2866560247f48f9c","33":"08278bf52fc975bdc3ae","34":"01d0e5586d5412cc36ab","35":"8c8012958c237a9a9986","37":"46a8da05e435ee3cf010","38":"e2541011c400de6bed1c","39":"f61d19d9280d140109e0","40":"aa56b4077dd5cf822597","41":"3279ae7ddfcf406408aa","42":"1d24a1307d7443b4dd93","43":"4554fb62ce832f3d0013","44":"77c6df6f82f9d92add3f","45":"5f1b4c75b289e1a0a6ad","46":"eeeb776302eb3522883b","47":"e1fbf39c8fd1ea1e421d","48":"8aaf1169d3f265a0c6ad","49":"e19e295dd268c3fd7a34","50":"634153d0617adf41270d","51":"389491c4668810deba47","52":"07d61a01b09af36ff71e","53":"47a5569ff55873497b58","54":"35010fd01195c072be39","55":"38770052cdb27cae1f40","56":"275f202c059988d4e740","57":"36316d023a24379fcc2b","58":"f8ff20d4dd96836dbafb","59":"0ccde4da5abd190ff8cd","60":"2dddf6eb2c6e0e4233fc","61":"5d3d9b624ce2f6bdb27a","62":"53a407b5d77f8c0bcb6f","63":"bf1b462ddf0bce409aed","65":"02fdab9d8087265469c1","66":"98a2434550b076f0adf0","67":"b6da7d92751afd6a30c1","68":"b3c2c02ae539bb02778b","69":"eb71a2dc6f5287fee042","70":"ea4de3c5865012e91f26","71":"62f7606d862392240aa9","72":"77b8d3907af83320b937","74":"3181e27621c9999486c9","75":"e00b7816f2eaed10a9ff","76":"aaa7563a0a5c0649fd1d","77":"c8897e16607bd4a30d48","78":"910464ba66ec221573be"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"8":1,"9":1,"10":1,"14":1,"18":1,"20":1,"22":1,"23":1,"24":1,"26":1,"27":1,"28":1,"29":1,"31":1,"32":1,"34":1,"35":1,"38":1,"41":1,"42":1,"43":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"58":1,"59":1,"60":1,"61":1,"67":1,"69":1,"70":1,"71":1,"72":1,"74":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~reverse-image-search~stylequiz","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","7":"BuyItAgainTypeaheadPreWrapper","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews-mobile","12":"buybox~promotion-products-lazy","13":"compare~orange-lens","14":"media-gallery-overlay~media-gallery-overlay-mobile","15":"orange-lens~reverse-image-search","16":"ratings-and-reviews-desktop","17":"StoreLayout","18":"aisle-bay","19":"augmented-reality","20":"bath-renovation","21":"breadcrumbs","22":"browse-and-search","23":"browse-and-search-mobile","24":"buybox","25":"calculator-pipcalculator","26":"collections","27":"collections-mobile","28":"compare","29":"consumer-card-messaging","30":"customer-image-overlay","31":"drawer","32":"emt-generated-content","33":"emt-links","34":"fulfillment","35":"global-custom-configurator","37":"home","38":"magic-apron","39":"measurement-guide","40":"measurement-guide-overlay-content","41":"media-gallery-filmstrip-mobile","42":"media-gallery-overlay","43":"media-gallery-overlay-mobile","44":"message-types","45":"orange-lens","46":"order-sample","47":"order-sample-drawer","48":"overlay","49":"paint-reorder","50":"paint-reorder-mobile","51":"pep","52":"pep-mobile","53":"product","54":"product-mobile","55":"product-overview","56":"promotion-products-lazy","57":"question","58":"questions-and-answers","59":"quick-view","60":"ratings-and-reviews","61":"results","62":"returns-messaging","63":"reverse-image-search","65":"share-to-email-overlay","66":"share-to-pinterest-overlay","67":"size-guide-overlay","68":"specifications","69":"stylequiz","70":"vendor-collection-products","71":"vendor-collections","72":"vendor-collections-mobile","74":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"d72ddc6d6ad5d75cad74","1":"ae101fda583e7f2b6c7f","2":"2033e2b2c7759f5f4cb0","3":"993d4999fdb3e390bd0c","4":"89d9163eeb30e835d559","5":"50d430c72ccc3cf96a34","6":"f5a53b21f1e96abc5167","7":"31d6cfe0d16ae931b73c","8":"0ef658ad0521bc70e648","9":"d8b21b7e70d92d0b70e1","10":"6f5b9f83e7f38438fd0d","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"9cb446a01d4d917f1dbc","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"853e5ca78c8a7aa34a62","19":"31d6cfe0d16ae931b73c","20":"5033e42da1bac3702418","21":"31d6cfe0d16ae931b73c","22":"37afed82f8b28b621bc6","23":"433430c77ec86b77a3a3","24":"38d2233ec62d32df2250","25":"31d6cfe0d16ae931b73c","26":"2223c8eb283b24bd1aae","27":"7aeabf3c06271915b9e9","28":"21826578c6df476105cb","29":"eb405aa31c203a69394d","30":"31d6cfe0d16ae931b73c","31":"fc73174b407ad863c497","32":"b49004ddac99adec2224","33":"31d6cfe0d16ae931b73c","34":"ddf04856a4fe5106f34b","35":"1a5562a08d12f7682989","37":"31d6cfe0d16ae931b73c","38":"ceebf150d8a696023a14","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"beffd19446c8e7dc1ee9","42":"7013f93350fef54e51c5","43":"ef46722a6934367ca9d2","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"09f6da43f11c655db9ff","49":"d85cebdb6b33e393664b","50":"ff4c071276ae3b5b8c99","51":"5b190e758e405c03ce1f","52":"2c74100c63af83a2b66f","53":"49d1e6dcb79b8fe0a3bf","54":"592245600ffcc85065d9","55":"be155bb5d11dacdc4bb8","56":"defbf98c233545a10bef","57":"31d6cfe0d16ae931b73c","58":"d70c859b20e57c1599c5","59":"eebf9277c9a87e5363e9","60":"9d02d79dc9b8f52f7762","61":"7612ae7fca12602593b9","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"61cbd6424db4af076f0c","68":"31d6cfe0d16ae931b73c","69":"9e476a2a33be170c242f","70":"e518e335254638969e62","71":"5ccd412c357c08d11907","72":"3913df3b5f8f4b03041e","74":"1b8434094a82c1c3f8ba","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
